"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleSpinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CircleSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '2em' : _b, color = _a.color, style = _a.style, props = __rest(_a, ["size", "color", "style"]);
    var className = "spinner-border text-" + color;
    var styles = __assign({ verticalAlign: 'middle', borderWidth: '2.25px', height: size, width: size }, style);
    return (jsx_runtime_1.jsx("div", __assign({ className: className, role: "status", style: styles }, props, { children: jsx_runtime_1.jsx("span", __assign({ className: "sr-only" }, { children: "Loading..." }), void 0) }), void 0));
};
exports.CircleSpinner = CircleSpinner;
//# sourceMappingURL=CircleSpinner.js.map